"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withHoverBackgroundClass = exports.BigButton = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const withHoverBackgroundClass = exports.withHoverBackgroundClass = 'with-hover-background';
const BigButtonRoot = (0, _mui.styled)(_mui.ButtonBase)((param)=>{
    let { theme, ownerState } = param;
    return {
        alignItems: 'center',
        background: theme.palette.common.white,
        border: '1px solid transparent',
        borderRadius: theme.shape.largeComponentRadius,
        color: theme.palette.text.primary,
        display: 'flex',
        fontSize: theme.typography.body1.fontSize,
        padding: theme.spacing(4, 3),
        transition: theme.transitions.create([
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4, 6)
        },
        ...ownerState.showBorder && {
            border: "1px solid ".concat(theme.palette.grey[200])
        },
        '&:hover': {
            backgroundColor: (0, _mui.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity),
            color: theme.palette.text.primary,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        '&:active': {
            boxShadow: 'none'
        }
    };
});
const BigButtonContent = (0, _mui.styled)('span')((param)=>{
    let { theme, ownerState } = param;
    return {
        alignItems: 'center',
        color: theme.palette.text.primary,
        display: 'flex',
        gap: theme.spacing(3),
        justifyContent: 'center',
        justifySelf: 'stretch',
        overflow: 'hidden',
        ...ownerState.disabled && {
            color: theme.palette.action.disabled
        },
        ...ownerState.isHovering && {
            color: theme.palette.text.primary,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            },
            // styles applied on hover to elements in button content with the predefined CSS class
            [".".concat(withHoverBackgroundClass)]: {
                background: theme.palette.grey.A700
            }
        }
    };
});
const BigButton = exports.BigButton = /*#__PURE__*/ (0, _react.forwardRef)((inProps, ref)=>{
    const props = (0, _mui.useThemeProps)({
        props: inProps,
        name: 'BigButton'
    });
    const { children, className, disabled = false, disableFocusRipple = false, showBorder = true, ...other } = props;
    const [isHovering, setIsHovering] = (0, _react.useState)(false);
    const handleMouseOver = (0, _react.useCallback)(()=>{
        setIsHovering(true);
    }, []);
    const handleMouseOut = (0, _react.useCallback)(()=>{
        setIsHovering(false);
    }, []);
    const ownerState = {
        ...props,
        disabled,
        isHovering,
        showBorder
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BigButtonRoot, {
        ref: ref,
        centerRipple: true,
        className: className,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ownerState: ownerState,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BigButtonContent, {
            ownerState: ownerState,
            children: children
        })
    });
});
